module.exports = __webpack_public_path__ + "static/media/bg.bff45c8f.jpg";